import Vue from 'vue';
import { User } from '@/models/user/user';
import { getCurrentUser } from '@/resources/apollo/queries/me';
import { revokeAuthentication } from '@/resources/auth/auth';

export const authentication = Vue.observable<{ user?: User }>({ user: undefined });

function setUser(user: User): void {
  Vue.set(authentication, 'user', user);
}

function removeUser(): void {
  Vue.set(authentication, 'user', undefined);
}

export async function authenticate(): Promise<User> {
  const user = await getCurrentUser();
  setUser(user);

  return user;
}

export async function logout(): Promise<void> {
  removeUser();
  await revokeAuthentication();
}
